import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { ActionLabels, MarketplaceQuery, MarketplaceService, ProcessProviderId } from '@fgb/core';
import { firstValueFrom } from 'rxjs';
import { HideMobileNav } from '@fgb/portal-component-library/src/lib/directives';
import { NavigationService } from '@fgb/portal-component-library/src/lib/shared/services';

@Component({
  selector: 'fgb-marketplace-detail-page',
  templateUrl: './marketplace-detail-page.component.html',
  styleUrls: ['./marketplace-detail-page.component.scss'],
  hostDirectives: [HideMobileNav],
})
export class MarketplaceDetailPageComponent implements OnInit {
  id: number;
  actionLabels = ActionLabels;
  backButtonLink = '/rewards/marketplace';
  private destroyRef = inject(DestroyRef);
  private navigationService = inject(NavigationService);
  constructor(
    private route: ActivatedRoute,
    private marketplaceService: MarketplaceService,
    private marketplaceQuery: MarketplaceQuery,
    private router: Router
  ) {}

  ngOnInit() {
    this.navigationService.hideMobileNav();
    this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((param: any) => {
      this.id = param?.id;
      this._fetchMarketplace();
    });
  }
  ngOnDestroy(): void {
    this.navigationService.showMobileNav();
  }

  private _fetchMarketplace(): void {
    firstValueFrom(this.marketplaceService.fetchMarketplaceItemById(this.id))
      .then(() => this._setBackButtonLink())
      .catch(() => {
        this.router.navigate(['/404page']);
      });
  }

  /** Event items and marketplace items share this detail page, so send the back button to the page the item came from. */
  private _setBackButtonLink(): void {
    const item = this.marketplaceQuery.getEntity(this.id);
    const isEventItem =
      item?.ProcessProviderId === ProcessProviderId.Event || item?.ProcessProviderId === ProcessProviderId.VirtualEvent;
    this.backButtonLink = isEventItem ? '/rewards/events' : '/rewards/marketplace';
  }
}
